import { render, staticRenderFns } from "./StockPackagingBreakdownCell.vue?vue&type=template&id=0536ae78&scoped=true"
import script from "./StockPackagingBreakdownCell.vue?vue&type=script&lang=js"
export * from "./StockPackagingBreakdownCell.vue?vue&type=script&lang=js"
import style0 from "./StockPackagingBreakdownCell.vue?vue&type=style&index=0&id=0536ae78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536ae78",
  null
  
)

export default component.exports